/**
 * Safe Pinia store access for modules that may run before app.use(pinia).
 * Prevents: Cannot read properties of undefined (reading '_s')
 */
import { useAuthStore } from '@/domains/auth/store/authStore';
import { userStore } from '@/shared/store/userStore';

export function getPiniaStoreSafe(storeFn) {
  try {
    return storeFn();
  } catch {
    return null;
  }
}

export function getAuthStoreSafe() {
  return getPiniaStoreSafe(() => useAuthStore());
}

export function getUserStoreSafe() {
  return getPiniaStoreSafe(() => userStore());
}

export function shouldPreventApiCallSafe() {
  const auth = getAuthStoreSafe();
  return auth ? auth.shouldPreventApiCall : false;
}

export function isAuthLoggedOutSafe() {
  const auth = getAuthStoreSafe();
  return auth ? auth.isLoggedOut : false;
}

/** For WebSocket handlers and realtime side effects. */
export function canHandleRealtimeEventSafe() {
  return !isAuthLoggedOutSafe() && !shouldPreventApiCallSafe();
}
